/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pr_Type_LabelInputs */

const fr_pr_type_label = /** @type {(inputs: Pr_Type_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Type de PR`)
};

/**

* @param {Pr_Type_LabelInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const pr_type_label = /** @type {((inputs?: Pr_Type_LabelInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pr_Type_LabelInputs, { locale?: "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_pr_type_label(inputs)
});